webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Review__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Review___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Review__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/review/:uuid',
    name: 'Review',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Review___default.a
  }]
}));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(45),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, exports) {

module.exports = {"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lang_js__ = __webpack_require__(37);



__webpack_require__(39);


function status(status, lang) {
    switch (status) {
        case 1:
            return lang.status_1;break;
        case 2:
            return lang.status_2;break;
        case 3:
            return lang.status_3;break;
        case 4:
            return lang.status_4;break;
    }
}
function dateFormat(dateString, lang) {
    var d = new Date(dateString);
    var month = lang['month_' + (d.getMonth() + 1)];
    return d.getDate() + ' ' + month;
}

function addSeconds(dateString, seconds) {
    return new Date(new Date(dateString).getTime() + seconds * 1000).toISOString();
}

var serviceLocation = this.$selfServiceLocation;
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Review',
    data: function data() {
        return {
            questionnaire: null,
            notification: null,
            uuid: this.$route.params.uuid,
            lang: __WEBPACK_IMPORTED_MODULE_1__lang_js__["a" /* FR */],
            curLang: 'FR',
            supportedLang: ['EN', 'FR', 'DE', 'IT', 'ES']
        };
    },
    mounted: function mounted() {
        if (navigator && navigator.language) {
            var lang = navigator.language;

            if (lang.indexOf('-') !== -1) {
                lang = lang.substring(0, lang.indexOf('-'));
            }

            lang = lang.toUpperCase();

            if (this.supportedLang.indexOf(lang) !== -1) {
                this.curLang = lang;
            }
        }
        this.loadLang(this.load);
    },

    methods: {
        load: function load() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$selfServiceLocation + '/questionnaire/' + this.curLang + '/' + this.uuid).then(function (response) {
                if (response.status !== 200) {
                    if (response.status === 404) {
                        _this.setNotification('error', '404 ' + _this.uuid);
                    } else {
                        _this.setNotification('error', '500 ' + _this.uuid);
                    }
                    return;
                }

                var questionnaire = response.data;
                questionnaire.status = status(questionnaire.status, _this.lang);
                questionnaire.expires_at = dateFormat(addSeconds(questionnaire.created_at, 14 * 24 * 60 * 60), _this.lang);
                questionnaire.created_at = dateFormat(questionnaire.created_at, _this.lang);

                if (questionnaire.decided_at != undefined) {
                    questionnaire.decided_at = dateFormat(questionnaire.decided_at, _this.lang);
                }

                _this.questionnaire = questionnaire;
            }).catch(function () {
                _this.setNotification('error', _this.lang.error_500 + ' ' + _this.uuid);
            });
        },
        loadLang: function loadLang(callback) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$selfServiceLocation + '/translations/' + this.curLang).then(function (response) {
                if (response.status !== 200) {
                    if (response.status === 404) {
                        _this2.setNotification('error', 'error 404 ' + _this2.uuid);
                    } else {
                        _this2.setNotification('error', 'error 500 ' + _this2.uuid);
                    }
                    return;
                }

                _this2.lang = response.data;
                if (callback) {
                    callback();
                }
            }).catch(function () {
                _this2.setNotification('error', _this2.lang.error_500 + ' ' + _this2.uuid);
            });
        },
        changelang: function changelang(language) {
            this.curLang = language;
            this.loadLang(this.load);
        },
        FR: function FR() {
            this.curLang = 'FR';
            this.loadLang(this.load);
        },
        EN: function EN() {
            this.curLang = 'EN';
            this.loadLang(this.load);
        },
        DE: function DE() {
            this.curLang = 'DE';
            this.loadLang(this.load);
        },
        IT: function IT() {
            this.curLang = 'IT';
            this.loadLang(this.load);
        },
        ES: function ES() {
            this.curLang = 'ES';
            this.loadLang(this.load);
        },
        accept: function accept() {
            this.decide(2);
        },
        reject: function reject() {
            this.decide(3);
        },
        decide: function decide(s) {
            var _this3 = this;

            this.status = s;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.$selfServiceLocation + '/questionnaire/update', {
                hash: this.uuid,
                status: s
            }).then(function () {
                _this3.setNotification('success', 'The status has been changed to ' + status(_this3.status, _this3.lang));
                _this3.questionnaire.status = status(_this3.status, _this3.lang);
            }).catch(function () {
                _this3.setNotification('error', 'The status could not be changed to ' + status(_this3.status, _this3.lang));
            });
        },
        setNotification: function setNotification(t, m) {
            this.notification = { type: t, message: m };
        },
        clearNotification: function clearNotification() {
            this.notification = null;
        }
    }
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FR; });
var EN = {
    downgrade_cracked_screen: {
        translation: "Cracked Screen"
    },
    downgrade_cosmetics: {
        translation: "Cosmetics"
    },
    downgrade_lcd_issues: {
        translation: "LCD issues"
    },
    downgrade_functionality: {
        translation: "Functionality"
    },
    downgrade_battery: {
        translation: "Battery"
    },
    downgrade_no_power: {
        translation: "No power"
    },
    downgrade_account_lock: {
        translation: "Account lock"
    },
    downgrade_changed_product: {
        translation: "Changed Product"
    },
    title_trade_in_summary: {
        translation: "Trade-in Summary"
    },
    title_item: {
        translation: "Item"
    },
    title_value: {
        translation: "Order Reference"
    },
    title_reference: {
        translation: "Reference"
    },
    title_original_value: {
        translation: "Original Value"
    },
    title_inspected_value: {
        translation: "Inspected Value"
    },
    title_status: {
        translation: "Status"
    },
    title_created_at: {
        translation: "Date Created"
    },
    title_expires_at: {
        translation: "Date Expires"
    },
    title_decision_made_at: {
        translation: "Decision Made At"
    },
    title_item_breakdown: {
        translation: "Item Breakdown"
    },
    title_item_reference: {
        translation: "Item Reference"
    },
    title_item_name: {
        translation: "Item Name"
    },
    title_downgrade_reason: {
        translation: "Downgrade Reason"
    },
    title_quoted_grade: {
        translation: "Quoted Grade"
    },
    title_current_grade: {
        translation: "Current Grade"
    },
    title_quoted_value: {
        translation: "Quoted Value"
    },
    title_current_value: {
        translation: "Current Value"
    },
    title_accept_reject_offer: {
        translation: "Please accept or reject the assessed offer"
    },
    text_accept_reject: {
        translation: "Please note that the offer is only valid for 14 days. If no response is recorded, the offer will be automatically rejected and your device will be sent back to you. "
    },
    text_decision_made: {
        translation: "The decision has already been made on this item"
    },
    button_accept: {
        translation: "Accept"
    },
    button_reject: {
        translation: "Reject"
    },
    error_404: {
        translation: "Could not find the order"
    },
    error_500: {
        translation: "Something has gone wrong fetching the order"
    },
    month_1: {
        translation: "January"
    },
    month_2: {
        translation: "February"
    },
    month_3: {
        translation: "March"
    },
    month_4: {
        translation: "April"
    },
    month_5: {
        translation: "May"
    },
    month_6: {
        translation: "June"
    },
    month_7: {
        translation: "July"
    },
    month_8: {
        translation: "August"
    },
    month_9: {
        translation: "September"
    },
    month_10: {
        translation: "October"
    },
    month_11: {
        translation: "November"
    },
    month_12: {
        translation: "December"
    }
};

var FR = {
    downgrade_cracked_screen: {
        translation: "Écran fissuré"
    },
    downgrade_cosmetics: {
        translation: "Cosmétiques"
    },
    downgrade_lcd_issues: {
        translation: "Problèmes d'écran LCD"
    },
    downgrade_functionality: {
        translation: "Fonctionnalité"
    },
    downgrade_battery: {
        translation: "Batterie"
    },
    downgrade_no_power: {
        translation: "Pas de puissance"
    },
    downgrade_account_lock: {
        translation: "Verrouillage de compte"
    },
    downgrade_changed_product: {
        translation: "Produit modifié"
    },
    title_trade_in_summary: {
        translation: "Résumé de l’échange"
    },
    title_item: {
        translation: "L'objet"
    },
    title_value: {
        translation: "Référence de l'achat"
    },
    title_reference: {
        translation: "Référence"
    },
    title_original_value: {
        translation: "Valeur d’origine"
    },
    title_inspected_value: {
        translation: "Valeur inspectée"
    },
    title_status: {
        translation: "Statut"
    },
    title_created_at: {
        translation: "Date créée"
    },
    title_expires_at: {
        translation: "Date d'expiration"
    },
    title_decision_made_at: {
        translation: "Décision prise à"
    },
    title_item_breakdown: {
        translation: "Détails de la commande"
    },
    title_item_reference: {
        translation: "Référence l'objet"
    },
    title_item_name: {
        translation: "Description l'objet"
    },
    title_downgrade_reason: {
        translation: "Raison de déclassement"
    },
    title_quoted_grade: {
        translation: "Classe citée"
    },
    title_current_grade: {
        translation: "Classe actuelle"
    },
    title_quoted_value: {
        translation: "Valeur citée"
    },
    title_current_value: {
        translation: "Valeur actuelle"
    },
    title_accept_reject_offer: {
        translation: "Veuillez accepter ou refuser l'offre évaluée"
    },
    text_accept_reject: {
        translation: "Veuillez noter que l'offre n'est valable que 14 jours. Si aucune réponse n'est enregistrée, l'offre sera automatiquement rejetée et votre appareil vous sera renvoyé"
    },
    text_decision_made: {
        translation: "La décision a déjà été prise sur ce point"
    },
    button_accept: {
        translation: "Accepter"
    },
    button_reject: {
        translation: "Rejeter"
    },
    error_404: {
        translation: "Quelque chose s’est mal passé pour aller chercher l’ordre"
    },
    error_500: {
        translation: "N’a pas pu trouver l’ordre"
    },
    month_1: {
        translation: "Janvier"
    },
    month_2: {
        translation: "Février"
    },
    month_3: {
        translation: "Mars"
    },
    month_4: {
        translation: "Avril"
    },
    month_5: {
        translation: "Mai"
    },
    month_6: {
        translation: "Juin"
    },
    month_7: {
        translation: "Julliet"
    },
    month_8: {
        translation: "Août"
    },
    month_9: {
        translation: "Septembre"
    },
    month_10: {
        translation: "Octobre"
    },
    month_11: {
        translation: "Novembre"
    },
    month_12: {
        translation: "Décembre"
    }
};

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(14);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

var selfServiceLocation;
switch ("production") {
  case 'development':
    selfServiceLocation = 'http://127.0.0.1:6677/api/v1';
    break;
  case 'production':
    selfServiceLocation = 'https://api.live.alchemy-connect.com/mytrade/api/v1';
    break;
  case 'uat':
    selfServiceLocation = 'https://api.uat.alchemy-connect.com/mytrade/api/v1';
    break;
}
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$selfServiceLocation = selfServiceLocation;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 39 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(40)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(44),
  /* scopeId */
  "data-v-33b56cec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Review"
  }, [(_vm.notification !== null) ? _c('div', [_c('div', {
    staticClass: "notification",
    class: {
      error: _vm.notification.type === 'error', success: _vm.notification.type === 'success'
    }
  }, [_c('span', {
    on: {
      "click": _vm.clearNotification
    }
  }, [_vm._v("x")]), _vm._v("\n          " + _vm._s(_vm.notification.message) + "\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "float-right lang-selector"
  }, [_c('a', {
    class: {
      active: _vm.curLang === 'FR'
    },
    on: {
      "click": function($event) {
        return _vm.changelang('FR')
      }
    }
  }, [_vm._v("🇫🇷")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.curLang === 'EN'
    },
    on: {
      "click": function($event) {
        return _vm.changelang('EN')
      }
    }
  }, [_vm._v("🇬🇧")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.curLang === 'DE'
    },
    on: {
      "click": function($event) {
        return _vm.changelang('DE')
      }
    }
  }, [_vm._v("🇩🇪")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.curLang === 'IT'
    },
    on: {
      "click": function($event) {
        return _vm.changelang('IT')
      }
    }
  }, [_vm._v("🇮🇹")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.curLang === 'ES'
    },
    on: {
      "click": function($event) {
        return _vm.changelang('ES')
      }
    }
  }, [_vm._v("🇪🇸")])]), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "questionnaire-main-header"
    }
  }, [_vm._v(_vm._s(_vm.lang.title_trade_in_summary))]), _vm._v(" "), (_vm.questionnaire !== null) ? _c('div', [_c('table', {
    attrs: {
      "aria-describedby": "questionnaire-main-header"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.title_created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.questionnaire.created_at))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.title_expires_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.questionnaire.expires_at))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.title_value))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.questionnaire.reference))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.title_original_value))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.questionnaire.currency_symbol) + _vm._s(_vm.questionnaire.original_value))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.title_inspected_value))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.questionnaire.currency_symbol) + _vm._s(_vm.questionnaire.inspected_value))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.title_status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.questionnaire.status))])]), _vm._v(" "), (_vm.questionnaire.decided_at !== null) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.title_decision_made_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.questionnaire.decided_at))])]) : _vm._e()])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "item-breakdown-header"
    }
  }, [_vm._v(_vm._s(_vm.lang.title_item_breakdown))]), _vm._v(" "), _c('table', {
    attrs: {
      "aria-describedby": "item-breakdown-header"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "column"
    }
  }, [_vm._v(_vm._s(_vm.lang.title_item_reference))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "column"
    }
  }, [_vm._v(_vm._s(_vm.lang.title_item_name))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "column"
    }
  }, [_vm._v(_vm._s(_vm.lang.title_downgrade_reason))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "column"
    }
  }, [_vm._v(_vm._s(_vm.lang.title_quoted_grade))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "column"
    }
  }, [_vm._v(_vm._s(_vm.lang.title_current_grade))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "column"
    }
  }, [_vm._v(_vm._s(_vm.lang.title_quoted_value))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "column"
    }
  }, [_vm._v(_vm._s(_vm.lang.title_current_value))])])]), _vm._v(" "), _vm._l((_vm.questionnaire.questionnaire_items), function(questionnaire_item) {
    return _c('tbody', {
      key: questionnaire_item.item_reference
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(questionnaire_item.item_reference))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(questionnaire_item.item_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(questionnaire_item.downgrade_reason))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.lang[("grade_" + (questionnaire_item.quoted_grade))]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.lang[("grade_" + (questionnaire_item.current_grade))]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.questionnaire.currency_symbol) + _vm._s(questionnaire_item.quoted_value))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.questionnaire.currency_symbol) + _vm._s(questionnaire_item.current_value))])])])
  })], 2), _vm._v(" "), (_vm.questionnaire.status == 'Awaiting Decision') ? _c('h2', [_vm._v(_vm._s(_vm.lang.title_accept_reject_offer))]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.questionnaire.status != _vm.lang.status_1) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.lang.text_decision_made))])]) : _c('div', [_c('p', [_vm._v(_vm._s(_vm.lang.text_accept_reject))]), _vm._v(" "), _c('a', {
    staticClass: "button accept",
    on: {
      "click": _vm.accept
    }
  }, [_vm._v(_vm._s(_vm.lang.button_accept))]), _vm._v(" "), _c('a', {
    staticClass: "button reject",
    on: {
      "click": _vm.reject
    }
  }, [_vm._v(_vm._s(_vm.lang.button_reject))])])])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ })
],[38]);


// WEBPACK FOOTER //
// static/js/app.b723d8bd8eb86d802106.js